import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewMapPerformanceGrades extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMapPerformanceGradesOpened: false
       }
    }

    getPerformanceDisplayValue = (performance) => {
        let mappedPerformance = this.props.mapOptions.filter(option => option.label === performance.label);
        if (mappedPerformance.length > 0)
            return mappedPerformance[0].label;
        else
            return '';
    }

    render() {
        let { allPerformanceMapping } = this.props.mapPerformance;
        let {isMapPerformanceGradesOpened} = this.state;
        let noOfPerformanceTypesMapped = allPerformanceMapping.filter(performanceMapping => performanceMapping.column!=="").length;
        
        return (<div className="review-sub-section">
            <Row>
                <Col sm="11" md="11" className="review-sub-section-heading">Mapped {noOfPerformanceTypesMapped} of {allPerformanceMapping.length} values to performance ratings</Col>
                <Col sm="1" md="1" className={isMapPerformanceGradesOpened ? 'rotate-arrow' : 'text-center'}>
                    <i className={(isMapPerformanceGradesOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}
                        onClick={() => {
                            this.setState({ isMapPerformanceGradesOpened: !isMapPerformanceGradesOpened });
                        }} />
                </Col>
            </Row>
            <Collapse isOpen={isMapPerformanceGradesOpened}>
                 <div className="mt30 mapped-review-records">
                   {allPerformanceMapping.map((mappedPerformanceGrade, index) => {
                        return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                            {!mappedPerformanceGrade.value || mappedPerformanceGrade.value===undefined||mappedPerformanceGrade.value===null ||mappedPerformanceGrade.value==="null"|| mappedPerformanceGrade.value==="undefined"? 
                                mappedPerformanceGrade.value="empty"
                                :
                                mappedPerformanceGrade.value
                                } Performance Grade
                            </span>
                             {mappedPerformanceGrade.column!=="" &&mappedPerformanceGrade.column!==null ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{this.getPerformanceDisplayValue(mappedPerformanceGrade.column)}</span>
                            </span>: <span> left unmapped</span>}
                        </div>
                        )
                    })}
                </div> 
            </Collapse>
        </div>
                )
    }
}
